/*
  Shows the "your discount is active" bar when the session is carrying a discount code.

  Reads the discount_code cookie, which Shopify sets the moment someone follows a /discount/CODE
  link and which exists even with an empty cart. Then asks /cart.js for the amount actually saved,
  so once there is something in the cart the bar can say the number rather than the percentage -
  "you are saving $5.39" lands harder than "5% off".

  Dismissal is remembered per code, so dismissing WELCOME5 does not also hide a future promotion.
*/
(function () {
  'use strict';

  var STORE_KEY = 'je-discount-dismissed';

  function cookie(name) {
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i++) {
      var eq = parts[i].indexOf('=');
      if (eq > -1 && parts[i].slice(0, eq) === name) {
        try {
          return decodeURIComponent(parts[i].slice(eq + 1));
        } catch (e) {
          return parts[i].slice(eq + 1);
        }
      }
    }
    return '';
  }

  function dismissed(code) {
    try {
      return window.localStorage.getItem(STORE_KEY) === code;
    } catch (e) {
      /* Private mode and blocked storage both throw. A bar that shows again is a smaller
         problem than a script that stops here, so carry on as if nothing was dismissed. */
      return false;
    }
  }

  function remember(code) {
    try {
      window.localStorage.setItem(STORE_KEY, code);
    } catch (e) {}
  }

  function money(cents, format) {
    var amount = (cents / 100).toFixed(2);
    // Strip a trailing .00 so "$5.00" reads as "$5".
    if (amount.slice(-3) === '.00') amount = amount.slice(0, -3);
    return (format || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{[^}]*\}\}/, amount);
  }

  function init() {
    var bar = document.querySelector('[data-discount-bar]');
    if (!bar) return;

    var code = cookie('discount_code');
    if (!code || dismissed(code)) return;

    bar.querySelector('[data-discount-code]').textContent = code;
    bar.querySelector('[data-discount-message]').textContent = ' ' + (bar.getAttribute('data-message') || '');
    bar.hidden = false;
    // Set after unhiding so the transition has a frame to run from.
    window.requestAnimationFrame(function () {
      bar.classList.add('is-in');
    });

    bar.querySelector('[data-discount-dismiss]').addEventListener('click', function () {
      remember(code);
      bar.classList.remove('is-in');
      window.setTimeout(function () {
        bar.hidden = true;
      }, 220);
    });

    /*
      Upgrade the wording once there is a cart to discount. Deliberately non-blocking: if this
      request fails the bar still says the useful thing, it just does not name the amount.
    */
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart || !cart.total_discount || cart.item_count === 0) return;
        var saved = bar.querySelector('[data-discount-saved]');
        saved.textContent = 'You are saving ' + money(cart.total_discount, window.Shopify && window.Shopify.money_format) + '.';
        saved.hidden = false;
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
